import { render } from "./localizedText.vue?vue&type=template&id=0c6658d2&ts=true"
import script from "./localizedText.vue?vue&type=script&lang=ts"
export * from "./localizedText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__